import { apiClient } from "../apiClient";

const LICH_SU_NAP_DU_LIEU_API = "lich-su-nap-du-lieu-cong-dang-ky";

export const lichSuNapDuLieuCongDangKyApi = {
    SelectByQuyDinhId: (id_quy_dinh_dang_ky: number) => apiClient.get(`${LICH_SU_NAP_DU_LIEU_API}/${id_quy_dinh_dang_ky}`),
}